import { render } from "./sellerDashboard.vue?vue&type=template&id=38a27d39&scoped=true"
import script from "./sellerDashboard.vue?vue&type=script&lang=js"
export * from "./sellerDashboard.vue?vue&type=script&lang=js"

import "./sellerDashboard.vue?vue&type=style&index=0&id=38a27d39&media=screen&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a27d39"]])

export default __exports__